// Generated by Melange

import * as Buhta_components__LoadingDiv from "../../../../../packages/components/src/atoms/LoadingDiv.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

const _map = {"s":"s","m":"m","l":"l","xl":"xl"};

function sizeToJs(param) {
  return param;
}

function sizeFromJs(param) {
  return _map[param];
}

const _map$1 = {"default":"default","primary":"primary","secondary":"secondary","success":"success","warning":"warning","alert":"alert"};

function kindToJs(param) {
  return param;
}

function kindFromJs(param) {
  return _map$1[param];
}

const _map$2 = {"Default":"Default","Loading":"Loading"};

function stateToJs(param) {
  return param;
}

function stateFromJs(param) {
  return _map$2[param];
}

function button(kind, size, isWide, disabled) {
  const kindRules = function (param) {
    if (param === "secondary") {
      return "bg-secondary text-white";
    } else if (param === "primary") {
      return "bg-links hover:bg-links-hover active:bg-links-active text-white";
    } else if (param === "default") {
      return "bg-white border border-gray-main text-black hover:border-default-gray active:border-gray-medium active:scale-100";
    } else if (param === "alert") {
      return "bg-alert text-white";
    } else if (param === "success") {
      return "bg-success text-white";
    } else {
      return "bg-links hover:bg-links-hover active:bg-links-active text-white";
    }
  };
  const sizeRules = function (param) {
    if (param === "m") {
      return "text-sm py-2.5 px-4";
    } else if (param === "s") {
      return "font-medium text-xs px-4 py-2";
    } else if (param === "xl") {
      return "text-base leading-6 py-6 px-6";
    } else {
      return "text-base leading-6 py-3 px-6";
    }
  };
  return Cn.fromList({
    hd: "group relative rounded-sm box-border font-semibold whitespace-nowrap transition ease-in duration-250 focus:outline-hidden",
    tl: {
      hd: sizeRules(size),
      tl: {
        hd: Cn.on("bg-default-gray cursor-not-allowed", disabled),
        tl: {
          hd: Cn.on(kindRules(kind), !disabled),
          tl: {
            hd: Cn.on("w-full", isWide),
            tl: {
              hd: Cn.on("active:scale-100", !disabled),
              tl: /* [] */ 0
            }
          }
        }
      }
    }
  });
}

const Styles = {
  button: button
};

function Button(Props) {
  let sizeOpt = Props.size;
  let kindOpt = Props.kind;
  let stateOpt = Props.state;
  let name = Props.name;
  let value = Props.value;
  let type_Opt = Props.type_;
  let className = Props.className;
  let disabledOpt = Props.disabled;
  let isWideOpt = Props.isWide;
  let onClickOpt = Props.onClick;
  let children = Props.children;
  const size = sizeOpt !== undefined ? sizeOpt : "l";
  const kind = kindOpt !== undefined ? kindOpt : "primary";
  const state = stateOpt !== undefined ? stateOpt : "Default";
  const type_ = type_Opt !== undefined ? type_Opt : "button";
  const disabled = disabledOpt !== undefined ? disabledOpt : false;
  const isWide = isWideOpt !== undefined ? isWideOpt : false;
  const onClick = onClickOpt !== undefined ? onClickOpt : (function (_ev) {
      
    });
  let tmp = {
    children: state === "Default" ? children : JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {
        size: size === "m" ? "w-5 h-5" : (
            size === "s" ? "w-4 h-4" : "w-6 h-6"
          ),
        borderWidth: "border-2",
        primaryColor: kind === "default" ? "border-black" : "border-white",
        secondaryColor: "border-t-transparent"
      }),
    className: Cn.fromList({
      hd: button(kind, size, isWide, disabled),
      tl: {
        hd: Cn.take(className),
        tl: /* [] */ 0
      }
    }),
    disabled: disabled,
    type: type_,
    onClick: Curry.__1(onClick)
  };
  if (name !== undefined) {
    tmp.name = Caml_option.valFromOption(name);
  }
  if (value !== undefined) {
    tmp.value = Caml_option.valFromOption(value);
  }
  return JsxRuntime.jsx("button", tmp);
}

const make = Button;

export {
  sizeToJs,
  sizeFromJs,
  kindToJs,
  kindFromJs,
  stateToJs,
  stateFromJs,
  Styles,
  make,
}
/* Buhta_components__LoadingDiv Not a pure module */
